import React from 'react';
import { BrowserRouter, } from 'react-router-dom';
import { ThemeProvider, createTheme, } from '@mui/material/styles'
import AppRouter from './routers/AppRouter';
import { GroupStateProvider } from './context/GroupStateContext';

const theme = createTheme({
  typography: {
    fontSize: 14,
    button: {
      fontWeight: 600,
    }
  },
  palette: {
    black: "#000000",
    primary: {
      main: "#4265D6", 
      contrastText: "#ffffff", 
    },
    secondary: {
      main: "#293855", 
      contrastText: "#ffffff", 
    },
  },
});

function App() {
  return (
    <GroupStateProvider>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </ThemeProvider>
    </GroupStateProvider>
    
  );
}

export default App;
